var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4801_38766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.23438C5.48759 2.23438 2.23438 5.48876 2.23438 9.5C2.23438 13.5136 5.48759 16.7656 9.5 16.7656C13.5124 16.7656 16.7656 13.5136 16.7656 9.5C16.7656 5.48876 13.5124 2.23438 9.5 2.23438ZM9.5 5.45703C10.1796 5.45703 10.7305 6.00793 10.7305 6.6875C10.7305 7.36707 10.1796 7.91797 9.5 7.91797C8.82043 7.91797 8.26953 7.36707 8.26953 6.6875C8.26953 6.00793 8.82043 5.45703 9.5 5.45703ZM11.1406 12.8984C11.1406 13.0926 10.9832 13.25 10.7891 13.25H8.21094C8.01679 13.25 7.85938 13.0926 7.85938 12.8984V12.1953C7.85938 12.0012 8.01679 11.8438 8.21094 11.8438H8.5625V9.96875H8.21094C8.01679 9.96875 7.85938 9.81134 7.85938 9.61719V8.91406C7.85938 8.71991 8.01679 8.5625 8.21094 8.5625H10.0859C10.2801 8.5625 10.4375 8.71991 10.4375 8.91406V11.8438H10.7891C10.9832 11.8438 11.1406 12.0012 11.1406 12.1953V12.8984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4801_38766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.54c4bac58358d4ddf5e4e11e27a94f14.svg";
export { ForwardRef as ReactComponent };